import React from 'react'
import FlatTextField from '@components/FlatTextField'
import { CircularProgress, IconButton, InputAdornment } from '@mui/material'
import { Close, Search } from '@mui/icons-material'
import { debounce } from 'lodash'

export function SearchTextField({
  searchState = [],
  size = 'medium',
  InputProps = {},
  isLoading = false,
  ...props
}) {
  const [search, setSearch] = searchState
  const handleSearchChange = React.useCallback(
    debounce((value) => setSearch(value), 500),
    []
  )

  const textRef = React.useRef(search)
  React.useEffect(() => {
    textRef.current.value = search
  }, [search])
  return (
    <FlatTextField
      ref={textRef}
      onChange={(e) => handleSearchChange(e.target.value)}
      backgroundColor="white"
      size={size}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Search />
          </InputAdornment>
        ),
        endAdornment: !!search && (
          <InputAdornment
            position="end"
            onClick={() => setSearch('')}
          >
            {isLoading ? (
              <CircularProgress size={14} />
            ) : (
              <IconButton
                size={size}
                edge="end"
              >
                <Close fontSize="inherit" />
              </IconButton>
            )}
          </InputAdornment>
        ),
        ...InputProps,
      }}
      {...props}
    />
  )
}

export default SearchTextField
